// MYZIURA 1 explanation
export default {
  sections: [
    {
      name: 'Playground',
      slug: 'playground',
      topics: [
        {
          name: 'TikTok',
          slug: 'tiktok',
          exercises: [
            {
              text: 'I have ___ cat.',
              answers: ['a'],
              possibleAnswers: [['a', 'an', 'the']]
            }
          ]
        }
      ]
    },
    {
      name: 'Tutorial',
      slug: 'tutorial',
      topics: [
        {
          name: 'How it works',
          slug: 'how-it-works',
          possibleAnswers: [],
          totalExercises: 2,
          level: 'basic',
          exercises: [
            {
              index: 0,
              pageIndex: 0,
              text: 'I have ___ cat.',
              answers: ['a'],
              possibleAnswers: [['a', 'an', 'the']]
            },
            {
              index: 1,
              pageIndex: 0,
              text: 'How old ___ you?',
              answers: ['are'],
              possibleAnswers: [['are', 'is', 'am']]
            }
          ]
        }
      ]
    },

    {
      name: 'Basics',
      slug: 'basics',
      topics: [
        // {
        //   name: 'A vs An',
        //   slug: 'a-vs-an',
        //   possibleAnswers: ['a', 'an'],
        //   totalExercises: 1898
        // },
        {
          name: 'Articles',
          slug: 'articles',
          possibleAnswers: ['a', 'an', 'the'],
          totalExercises: 1893,
          level: 'basic',
          sources: [
            'https://vocaberry.com/wp-content/uploads/2024/10/articles-in-english-a-an-the-usage-learn-english-grammar-lesson-esl-vocaberry.png'
          ]
        },
        {
          name: 'Countable Uncountable',
          slug: 'countable-uncountable',
          possibleAnswers: ['cat', 'cats', 'apple', 'apples', 'milk'],
          totalExercises: 1759,
          level: 'basic'
        },
        // {
        //   name: 'Do Does Negative',
        //   slug: 'do-does-negative',
        //   possibleAnswers: ['does not', 'do not'],
        //   totalExercises: 1949
        // },
        {
          name: 'Do Does',
          slug: 'do-does',
          possibleAnswers: ['do', 'does'],
          totalExercises: 1997,
          level: 'basic',
          sources: [
            'https://imgix3.ruangguru.com/assets/miscellaneous/png_2z5zzk_86.png'
          ]
        },
        // {
        //   name: 'Have Has Negative',
        //   slug: 'have-has-negative',
        //   possibleAnswers: ['has not', 'have not'],
        //   totalExercises: 1648
        // },
        {
          name: 'Have Has',
          slug: 'have-has',
          possibleAnswers: ['has', 'have'],
          totalExercises: 473,
          level: 'basic',
          sources: [
            'https://preply.com/wp-content/uploads/2018/04/1-BhmvTHiw-s2k8bKyQ6V2-g-1.png'
          ]
        },
        {
          name: 'Mixed Prepositions',
          slug: 'mixed-prepositions',
          possibleAnswers: ['at', 'in', 'on'],
          totalExercises: 1973,
          level: 'basic'
        },
        {
          name: 'Nationalities Countries',
          slug: 'nationalities-countries',
          possibleAnswers: [],
          totalExercises: 1960,
          level: 'basic'
        },
        {
          name: 'Plurals',
          slug: 'plurals',
          possibleAnswers: [],
          totalExercises: 1444,
          level: 'basic',
          sources: [
            'https://i.ytimg.com/vi/6iD5scQMruM/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLALZlas4QelpdypzLPAHcxuEVg6Mg'
          ]
        },
        {
          name: 'Prepositions of Place',
          slug: 'prepositions-of-place',
          possibleAnswers: ['at', 'in', 'on'],
          totalExercises: 1999,
          level: 'basic',
          sources: [
            'https://www.woodwardenglish.com/wp-content/uploads/2019/09/prepositions-of-place-in-english.jpg'
          ]
        },
        {
          name: 'Prepositions of Time',
          slug: 'prepositions-of-time',
          possibleAnswers: ['at', 'in', 'on'],
          totalExercises: 1981,
          level: 'basic',
          sources: [
            'https://www.reddit.com/media?url=https%3A%2F%2Fpreview.redd.it%2Fa-cool-guide-to-prepositions-of-time-v0-dd6wht77e7ae1.jpeg%3Fauto%3Dwebp%26s%3D50af33959f3f2fdafbb2a9dd5c0b3a4ace43278f'
          ]
        },
        // {
        //   name: 'There Is There Are Negative',
        //   slug: 'there-is-there-are-negative',
        //   possibleAnswers: ['are not', 'is not'],
        //   totalExercises: 704
        // },
        {
          name: 'There Is There Are',
          slug: 'there-is-there-are',
          possibleAnswers: ['are', 'is'],
          totalExercises: 807,
          level: 'basic',
          sources: [
            'https://lh3.googleusercontent.com/proxy/tNIKqim5PphNyQW-ATsvevncfikW3KlGsfoxIqEetw9xl78dNpgy2r7q2DFYgtqA5KLoavsdjOxetzrNcB4g09xeWRmjgRi77SpyptUs0WqKAu67tcqfzU2bm5VK'
          ]
        },
        // {
        //   name: 'There Was There Were Negative',
        //   slug: 'there-was-there-were-negative',
        //   possibleAnswers: ['was not', 'were not'],
        //   totalExercises: 733
        // },
        {
          name: 'There Was There Were',
          slug: 'there-was-there-were',
          possibleAnswers: ['was', 'were'],
          totalExercises: 1418,
          level: 'basic',
          sources: [
            'https://lh3.googleusercontent.com/proxy/5GtWMdgcIcukcN8lTKVzKjCGNBNJwvMPrxgZUJ87vkeTN-20qk-lIv2t7miGbEWkMRGOhU2N-TA7qgPNLQOOkyXWo2W81GfES8dmjAYnGz8wo1LUh2GvGPoQpNTlGA_hnVYPx6ocuv_H'
          ]
        },
        {
          name: 'This That These Those',
          slug: 'this-that-these-those',
          possibleAnswers: ['that', 'these', 'this', 'those'],
          totalExercises: 1909,
          level: 'basic',
          sources: [
            'https://cambridge.ua/app/uploads/2023/08/raznycza-mezhdu-this-that-these-y-those_-kogda-upotreblyayutsya-y-na-chto-ukaz%D1%8Bvayut.jpg'
          ]
        },
        {
          name: 'To vs For',
          slug: 'to-vs-for',
          possibleAnswers: ['for', 'to'],
          totalExercises: 1893,
          level: 'intermediate'
        },
        // {
        //   name: 'Verb To Be Negative',
        //   slug: 'verb-to-be-negative',
        //   possibleAnswers: ['am not', 'are not', 'is not'],
        //   totalExercises: 1798
        // },
        {
          name: 'Verb To Be',
          slug: 'verb-to-be',
          possibleAnswers: ['am', 'are', 'is'],
          totalExercises: 1179,
          level: 'basic',
          sources: [
            'https://i0.wp.com/englishacademy101.com/wp-content/uploads/2019/11/the-present-tense-verb-to-be.png?resize=825%2C561&ssl=1'
          ]
        },
        // {
        //   name: 'Was Were Negative',
        //   slug: 'was-were-negative',
        //   possibleAnswers: ['was not', 'were not'],
        //   totalExercises: 1960
        // },
        {
          name: 'Was Were',
          slug: 'was-were',
          possibleAnswers: ['was', 'were'],
          totalExercises: 1846,
          level: 'basic'
        },
        {
          name: 'Wh Questions',
          slug: 'wh-questions',
          possibleAnswers: [
            'how',
            'what',
            'when',
            'where',
            'which',
            'who',
            'whom',
            'whose',
            'why'
          ],
          totalExercises: 2002,
          level: 'basic'
        },
        {
          name: 'When While',
          slug: 'when-while',
          possibleAnswers: ['when', 'while'],
          totalExercises: 1906,
          level: 'intermediate'
        }
      ]
    },
    {
      name: 'Adjective',
      slug: 'adjective',
      topics: [
        {
          name: 'All Every Whole',
          slug: 'all-every-whole',
          possibleAnswers: ['all', 'every', 'whole'],
          totalExercises: 1987,
          level: 'intermediate'
        },
        {
          name: 'Comparative Superlative',
          slug: 'comparative-superlative',
          possibleAnswers: [],
          totalExercises: 1334,
          level: 'basic'
        },
        {
          name: 'Comparative',
          slug: 'comparative',
          possibleAnswers: [],
          totalExercises: 1040,
          level: 'basic'
        },
        {
          name: 'Ed Ing Adjectives',
          slug: 'ed-ing-adjectives',
          possibleAnswers: [],
          totalExercises: 926,
          level: 'basic'
        },
        {
          name: 'Order of Adjectives',
          slug: 'order-of-adjectives',
          possibleAnswers: [],
          totalExercises: 493,
          level: 'basic'
        },
        {
          name: 'Other Another Others',
          slug: 'other-another-others',
          possibleAnswers: ['another', 'other', 'others'],
          totalExercises: 1975,
          level: 'intermediate'
        },
        {
          name: 'Quantifiers',
          slug: 'quantifiers',
          possibleAnswers: ['many', 'much', 'few', 'little'],
          totalExercises: 1999,
          level: 'advanced'
        },
        {
          name: 'Quite Rather',
          slug: 'quite-rather',
          possibleAnswers: ['quite', 'rather'],
          totalExercises: 2006,
          level: 'intermediate'
        },
        {
          name: 'Superlative',
          slug: 'superlative',
          possibleAnswers: [],
          totalExercises: 1262,
          level: 'basic'
        }
      ]
    },
    {
      name: 'Be',
      slug: 'be',
      topics: [
        {
          name: 'Be Able To',
          slug: 'be-able-to',
          possibleAnswers: [],
          totalExercises: 61,
          level: 'intermediate'
        },
        {
          name: 'Be Supposed To',
          slug: 'be-supposed-to',
          possibleAnswers: [],
          totalExercises: 91,
          level: 'intermediate'
        }
      ]
    },
    {
      name: 'Conditional',
      slug: 'conditional',
      topics: [
        {
          name: 'First vs Second Conditional',
          slug: 'first-vs-second-conditional',
          possibleAnswers: [],
          totalExercises: 855,
          level: 'intermediate'
        },
        {
          name: 'Mixed Conditionals',
          slug: 'mixed-conditionals',
          possibleAnswers: [],
          totalExercises: 1161,
          level: 'advanced'
        },
        {
          name: 'Second vs Third Conditional',
          slug: 'second-vs-third-conditional',
          possibleAnswers: [],
          totalExercises: 472,
          level: 'intermediate'
        }
      ]
    },
    {
      name: 'Future Tense',
      slug: 'future-tense',
      topics: [
        {
          name: 'Be Going To',
          slug: 'be-going-to',
          possibleAnswers: [],
          totalExercises: 547,
          level: 'basic'
        },
        {
          name: 'Future Continuous',
          slug: 'future-continuous',
          possibleAnswers: [],
          totalExercises: 141,
          level: 'intermediate'
        },
        {
          name: 'Future Perfect',
          slug: 'future-perfect',
          possibleAnswers: [],
          totalExercises: 128,
          level: 'intermediate'
        },
        {
          name: 'Future Simple',
          slug: 'future-simple',
          possibleAnswers: [],
          totalExercises: 850,
          level: 'basic'
        }
      ]
    },
    {
      name: 'Irregular',
      slug: 'irregular',
      topics: [
        {
          name: 'Past Participle Irregular',
          slug: 'past-participle-irregular',
          possibleAnswers: [],
          totalExercises: 1938,
          level: 'intermediate'
        },
        {
          name: 'Past Simple Irregular',
          slug: 'past-simple-irregular',
          possibleAnswers: [],
          totalExercises: 1789,
          level: 'intermediate'
        },
        {
          name: 'Past Simple Regular',
          slug: 'past-simple-regular',
          possibleAnswers: [],
          totalExercises: 1553,
          level: 'intermediate'
        }
      ]
    },
    {
      name: 'Modal',
      slug: 'modal',
      topics: [
        {
          name: 'Can Must Should',
          slug: 'can-must-should',
          possibleAnswers: ['can', 'must', 'should'],
          totalExercises: 2006,
          level: 'basic'
        },
        {
          name: 'Can vs Could',
          slug: 'can-vs-could',
          possibleAnswers: ['can', 'could'],
          totalExercises: 2012,
          level: 'basic'
        },
        // {
        //   name: 'Can',
        //   slug: 'can',
        //   possibleAnswers: [],
        //   totalExercises: 986
        // },
        // {
        //   name: 'Could',
        //   slug: 'could',
        //   possibleAnswers: [],
        //   totalExercises: 346
        // },
        {
          name: 'Dare',
          slug: 'dare',
          possibleAnswers: [],
          totalExercises: 89,
          level: 'advanced'
        },
        {
          name: 'Have To',
          slug: 'have-to',
          possibleAnswers: [],
          totalExercises: 60,
          level: 'intermediate'
        },
        {
          name: 'May Might',
          slug: 'may-might',
          possibleAnswers: [],
          totalExercises: 213,
          level: 'intermediate'
        },
        // {
        //   name: 'Must',
        //   slug: 'must',
        //   possibleAnswers: [],
        //   totalExercises: 283
        // },
        {
          name: 'Need',
          slug: 'need',
          possibleAnswers: [],
          totalExercises: 40,
          level: 'advanced'
        },
        {
          name: 'Ought To',
          slug: 'ought-to',
          possibleAnswers: [],
          totalExercises: 52,
          level: 'advanced'
        },
        {
          name: 'Shall',
          slug: 'shall',
          possibleAnswers: [],
          totalExercises: 87,
          level: 'advanced'
        },
        // {
        //   name: 'Should',
        //   slug: 'should',
        //   possibleAnswers: [],
        //   totalExercises: 294
        // },
        {
          name: 'Would vs Used To',
          slug: 'would-vs-used-to',
          possibleAnswers: ['used to', 'would'],
          totalExercises: 159,
          level: 'intermediate'
        },
        {
          name: 'Would',
          slug: 'would',
          possibleAnswers: [],
          totalExercises: 250,
          level: 'intermediate'
        }
      ]
    },
    {
      name: 'Multiple Choices',
      slug: 'multiple-choices',
      topics: [
        {
          name: 'Adverbs of Frequency',
          slug: 'adverbs-of-frequency',
          possibleAnswers: ['always', 'never', 'often'],
          totalExercises: 1377,
          level: 'basic'
        },
        {
          name: 'As Like',
          slug: 'as-like',
          possibleAnswers: ['as', 'like'],
          totalExercises: 1571,
          level: 'intermediate'
        },
        {
          name: 'Both Either Neither',
          slug: 'both-either-neither',
          possibleAnswers: ['both', 'either', 'neither'],
          totalExercises: 1851,
          level: 'intermediate'
        },
        {
          name: 'Coordinating Conjunctions',
          slug: 'coordinating-conjunctions',
          possibleAnswers: ['and', 'but', 'nor', 'or', 'so'],
          totalExercises: 2003,
          level: 'basic'
        },
        {
          name: 'Ever Never',
          slug: 'ever-never',
          possibleAnswers: ['ever', 'never'],
          totalExercises: 1979,
          level: 'intermediate'
        },
        {
          name: 'For Since Ago Until During',
          slug: 'for-since-ago-until-during',
          possibleAnswers: ['ago', 'during', 'for', 'since', 'until'],
          totalExercises: 2013,
          level: 'intermediate'
        },
        {
          name: 'How Much How Many',
          slug: 'how-much-how-many',
          possibleAnswers: ['many', 'much'],
          totalExercises: 1650,
          level: 'basic'
        },
        {
          name: 'Just Already Yet',
          slug: 'just-already-yet',
          possibleAnswers: ['already', 'just', 'yet'],
          totalExercises: 1984,
          level: 'basic'
        },
        // {
        //   name: 'Present Perfect With Ever Never',
        //   slug: 'present-perfect-with-ever-never',
        //   possibleAnswers: ['ever', 'never'],
        //   totalExercises: 893
        // },
        {
          name: 'Present Perfect With For Since',
          slug: 'present-perfect-with-for-since',
          possibleAnswers: ['for', 'since'],
          totalExercises: 1134,
          level: 'intermediate'
        },
        // {
        //   name: 'Present Perfect With Just Already Yet',
        //   slug: 'present-perfect-with-just-already-yet',
        //   possibleAnswers: ['already', 'just', 'yet'],
        //   totalExercises: 94
        // },
        {
          name: 'Relative Clauses',
          slug: 'relative-clauses',
          possibleAnswers: ['where', 'which', 'who', 'whom', 'whose'],
          totalExercises: 1668,
          level: 'intermediate'
        },
        {
          name: 'So Neither',
          slug: 'so-neither',
          possibleAnswers: ['neither', 'so'],
          totalExercises: 334,
          level: 'intermediate'
        },
        {
          name: 'Too Either',
          slug: 'too-either',
          possibleAnswers: ['either', 'too'],
          totalExercises: 234,
          level: 'intermediate'
        },
        {
          name: 'Too Enough',
          slug: 'too-enough',
          possibleAnswers: ['enough', 'too'],
          totalExercises: 2014,
          level: 'intermediate'
        },
        {
          name: 'Who Whom',
          slug: 'who-whom',
          possibleAnswers: ['who', 'whom'],
          totalExercises: 1959,
          level: 'intermediate'
        }
      ]
    },
    {
      name: 'Negative Form',
      slug: 'negative-form',
      topics: [
        {
          name: 'Be Going To Negative',
          slug: 'be-going-to-negative',
          possibleAnswers: [],
          totalExercises: 39,
          level: 'basic'
        },
        {
          name: 'Future Simple Negative',
          slug: 'future-simple-negative',
          possibleAnswers: [],
          totalExercises: 35,
          level: 'basic'
        },
        {
          name: 'Past Continuous Negative',
          slug: 'past-continuous-negative',
          possibleAnswers: [],
          totalExercises: 56,
          level: 'intermediate'
        },
        {
          name: 'Past Perfect Continuous Negative',
          slug: 'past-perfect-continuous-negative',
          possibleAnswers: [],
          totalExercises: 101,
          level: 'advanced'
        },
        {
          name: 'Past Perfect Negative',
          slug: 'past-perfect-negative',
          possibleAnswers: [],
          totalExercises: 42,
          level: 'advanced'
        },
        {
          name: 'Past Simple Negative',
          slug: 'past-simple-negative',
          possibleAnswers: [],
          totalExercises: 672,
          level: 'intermediate'
        },
        {
          name: 'Present Continuous Negative',
          slug: 'present-continuous-negative',
          possibleAnswers: [],
          totalExercises: 90,
          level: 'basic'
        },
        {
          name: 'Present Perfect Negative',
          slug: 'present-perfect-negative',
          possibleAnswers: [],
          totalExercises: 181,
          level: 'advanced'
        },
        {
          name: 'Present Simple Negative',
          slug: 'present-simple-negative',
          possibleAnswers: [],
          totalExercises: 1207,
          level: 'intermediate'
        }
      ]
    },
    {
      name: 'Noun',
      slug: 'noun',
      topics: [
        {
          name: 'A An Some Any',
          slug: 'a-an-some-any',
          possibleAnswers: ['a', 'an', 'any', 'some'],
          totalExercises: 1807,
          level: 'basic'
        },
        {
          name: 'Little Few',
          slug: 'little-few',
          possibleAnswers: ['few', 'little'],
          totalExercises: 2004,
          level: 'intermediate'
        },
        {
          name: 'Many Much',
          slug: 'many-much',
          possibleAnswers: ['many', 'much'],
          totalExercises: 2001,
          level: 'intermediate'
        },
        {
          name: 'One vs Ones',
          slug: 'one-vs-ones',
          possibleAnswers: ['one', 'ones'],
          totalExercises: 1397,
          level: 'intermediate'
        },
        {
          name: 'So Such',
          slug: 'so-such',
          possibleAnswers: ['so', 'such'],
          totalExercises: 1964,
          level: 'intermediate'
        },
        {
          name: 'Some Any',
          slug: 'some-any',
          possibleAnswers: ['any', 'some'],
          totalExercises: 2013,
          level: 'basic'
        }
      ]
    },
    {
      name: 'Passive Voice',
      slug: 'passive-voice',
      topics: [
        {
          name: 'Future Perfect Passive',
          slug: 'future-perfect-passive',
          possibleAnswers: [],
          totalExercises: 65,
          level: 'advanced'
        },
        {
          name: 'Future Simple Passive',
          slug: 'future-simple-passive',
          possibleAnswers: [],
          totalExercises: 499,
          level: 'intermediate'
        },
        {
          name: 'Passive Voice',
          slug: 'passive-voice',
          possibleAnswers: [],
          totalExercises: 1020,
          level: 'intermediate'
        },
        {
          name: 'Past Continuous Passive',
          slug: 'past-continuous-passive',
          possibleAnswers: [],
          totalExercises: 368,
          level: 'advanced'
        },
        {
          name: 'Past Perfect Passive',
          slug: 'past-perfect-passive',
          possibleAnswers: [],
          totalExercises: 269,
          level: 'advanced'
        },
        {
          name: 'Past Simple Passive',
          slug: 'past-simple-passive',
          possibleAnswers: [],
          totalExercises: 859,
          level: 'intermediate'
        },
        {
          name: 'Present Continuous Passive',
          slug: 'present-continuous-passive',
          possibleAnswers: [],
          totalExercises: 326,
          level: 'advanced'
        },
        {
          name: 'Present Perfect Passive',
          slug: 'present-perfect-passive',
          possibleAnswers: [],
          totalExercises: 411,
          level: 'advanced'
        },
        {
          name: 'Present Simple Passive',
          slug: 'present-simple-passive',
          possibleAnswers: [],
          totalExercises: 618,
          level: 'intermediate'
        }
      ]
    },
    {
      name: 'Past Future',
      slug: 'past-future',
      topics: [
        {
          name: 'Past Future Continuous',
          slug: 'past-future-continuous',
          possibleAnswers: [],
          totalExercises: 46,
          level: 'advanced'
        },
        {
          name: 'Past Future Perfect',
          slug: 'past-future-perfect',
          possibleAnswers: [],
          totalExercises: 49,
          level: 'advanced'
        }
      ]
    },
    {
      name: 'Past Tense',
      slug: 'past-tense',
      topics: [
        {
          name: 'Past Continuous',
          slug: 'past-continuous',
          possibleAnswers: [],
          totalExercises: 1017,
          level: 'intermediate'
        },
        {
          name: 'Past Perfect Continuous',
          slug: 'past-perfect-continuous',
          possibleAnswers: [],
          totalExercises: 345,
          level: 'advanced'
        },
        {
          name: 'Past Perfect',
          slug: 'past-perfect',
          possibleAnswers: [],
          totalExercises: 1071,
          level: 'intermediate'
        },
        {
          name: 'Past Simple',
          slug: 'past-simple',
          possibleAnswers: [],
          totalExercises: 1342,
          level: 'intermediate'
        }
      ]
    },
    // {
    //   name: 'Positive Form',
    //   slug: 'positive-form',
    //   topics: [
    //     {
    //       name: 'Be Going To Positive',
    //       slug: 'be-going-to-positive',
    //       possibleAnswers: [],
    //       totalExercises: 32
    //     },
    //     {
    //       name: 'Be Used To Positive',
    //       slug: 'be-used-to-positive',
    //       possibleAnswers: [
    //         'was used to',
    //         'were used to',
    //         'are used to',
    //         'is used to',
    //         'had been used to traslating',
    //         'was used to translating'
    //       ],
    //       totalExercises: 102
    //     },
    //     {
    //       name: 'Have Has Got Positive',
    //       slug: 'have-has-got-positive',
    //       possibleAnswers: ['has got', 'have got', 'had got'],
    //       totalExercises: 128
    //     },
    //     {
    //       name: 'Past Continuous Positive',
    //       slug: 'past-continuous-positive',
    //       possibleAnswers: [],
    //       totalExercises: 23
    //     },
    //     {
    //       name: 'Past Perfect Continuous Positive',
    //       slug: 'past-perfect-continuous-positive',
    //       possibleAnswers: [],
    //       totalExercises: 327
    //     },
    //     {
    //       name: 'Past Perfect Positive',
    //       slug: 'past-perfect-positive',
    //       possibleAnswers: [],
    //       totalExercises: 68
    //     },
    //     {
    //       name: 'Past Simple Positive',
    //       slug: 'past-simple-positive',
    //       possibleAnswers: [],
    //       totalExercises: 1404
    //     },
    //     {
    //       name: 'Present Continuous Positive',
    //       slug: 'present-continuous-positive',
    //       possibleAnswers: [],
    //       totalExercises: 643
    //     },
    //     {
    //       name: 'Present Perfect Continuous Positive',
    //       slug: 'present-perfect-continuous-positive',
    //       possibleAnswers: [],
    //       totalExercises: 21
    //     },
    //     {
    //       name: 'Present Perfect Positive',
    //       slug: 'present-perfect-positive',
    //       possibleAnswers: [],
    //       totalExercises: 631
    //     },
    //     {
    //       name: 'Present Simple Positive',
    //       slug: 'present-simple-positive',
    //       possibleAnswers: [],
    //       totalExercises: 1532
    //     },
    //     {
    //       name: 'Used To Positive',
    //       slug: 'used-to-positive',
    //       possibleAnswers: [
    //         'use to do',
    //         'used to do',
    //         'uesed to think',
    //         'used to think',
    //         'used to',
    //         'used to fight'
    //       ],
    //       totalExercises: 35
    //     },
    //     {
    //       name: 'Would Rather Positive',
    //       slug: 'would-rather-positive',
    //       possibleAnswers: [
    //         'would rather',
    //         'would rather die',
    //         'would rather be chained',
    //         'would rather chain',
    //         'would rather be execute',
    //         'would rather be executed',
    //         'would rather execute'
    //       ],
    //       totalExercises: 124
    //     }
    //   ]
    // },
    {
      name: 'Present Tense',
      slug: 'present-tense',
      topics: [
        {
          name: 'Present Continuous',
          slug: 'present-continuous',
          possibleAnswers: [],
          totalExercises: 901,
          level: 'basic'
        },
        {
          name: 'Present Perfect Continuous',
          slug: 'present-perfect-continuous',
          possibleAnswers: [],
          totalExercises: 273,
          level: 'intermediate'
        },
        {
          name: 'Present Perfect',
          slug: 'present-perfect',
          possibleAnswers: [],
          totalExercises: 1358,
          level: 'intermediate'
        },
        {
          name: 'Present Simple',
          slug: 'present-simple',
          possibleAnswers: [],
          totalExercises: 1460,
          level: 'basic'
        }
      ]
    },
    {
      name: 'Pronoun',
      slug: 'pronoun',
      topics: [
        {
          name: 'Indefinite Pronouns',
          slug: 'indefinite-pronouns',
          possibleAnswers: ['any', 'every', 'no', 'some'],
          totalExercises: 1992,
          level: 'intermediate'
        },
        {
          name: 'Objective Pronouns',
          slug: 'objective-pronouns',
          possibleAnswers: [],
          totalExercises: 2014,
          level: 'intermediate'
        },
        {
          name: 'Personal Pronouns',
          slug: 'personal-pronouns',
          possibleAnswers: [],
          totalExercises: 2014,
          level: 'basic'
        },
        {
          name: 'Possessive Adjectives',
          slug: 'possessive-adjectives',
          possibleAnswers: [],
          totalExercises: 1895,
          level: 'basic'
        },
        {
          name: 'Possessive Pronouns',
          slug: 'possessive-pronouns',
          possibleAnswers: [],
          totalExercises: 1958,
          level: 'intermediate'
        },
        {
          name: 'Reflexive Pronouns',
          slug: 'reflexive-pronouns',
          possibleAnswers: [],
          totalExercises: 2011,
          level: 'intermediate'
        },
        {
          name: 'Subjective Pronouns',
          slug: 'subjective-pronouns',
          possibleAnswers: [],
          totalExercises: 2014,
          level: 'basic'
        }
      ]
    },
    {
      name: 'Question Form',
      slug: 'question-form',
      topics: [
        {
          name: 'Be Going To Question',
          slug: 'be-going-to-question',
          possibleAnswers: [],
          totalExercises: 99,
          level: 'basic'
        },
        {
          name: 'Future Simple Question',
          slug: 'future-simple-question',
          possibleAnswers: [],
          totalExercises: 24,
          level: 'basic'
        },
        {
          name: 'Have Has Got Question',
          slug: 'have-has-got-question',
          possibleAnswers: [],
          totalExercises: 43,
          level: 'basic'
        },
        {
          name: 'Past Perfect Continuous Question',
          slug: 'past-perfect-continuous-question',
          possibleAnswers: [],
          totalExercises: 28,
          level: 'advanced'
        },
        {
          name: 'Past Simple Question',
          slug: 'past-simple-question',
          possibleAnswers: [],
          totalExercises: 221,
          level: 'intermediate'
        },
        {
          name: 'Present Continuous Question',
          slug: 'present-continuous-question',
          possibleAnswers: [],
          totalExercises: 53,
          level: 'basic'
        },
        {
          name: 'Present Perfect Question',
          slug: 'present-perfect-question',
          possibleAnswers: [],
          totalExercises: 26,
          level: 'intermediate'
        },
        {
          name: 'Present Simple Question',
          slug: 'present-simple-question',
          possibleAnswers: [],
          totalExercises: 195,
          level: 'basic'
        }
      ]
    },
    {
      name: 'Used To',
      slug: 'used-to',
      topics: [
        {
          name: 'Be Used To',
          slug: 'be-used-to',
          possibleAnswers: [],
          totalExercises: 448,
          level: 'advanced'
        },
        {
          name: 'Get Used To',
          slug: 'get-used-to',
          possibleAnswers: [],
          totalExercises: 94,
          level: 'advanced'
        },
        {
          name: 'Used To',
          slug: 'used-to',
          possibleAnswers: [],
          totalExercises: 112,
          level: 'intermediate'
        }
      ]
    },
    {
      name: 'Verb',
      slug: 'verb',
      topics: [
        {
          name: 'Auxiliary Verbs',
          slug: 'auxiliary-verbs',
          possibleAnswers: [],
          totalExercises: 1283,
          level: 'intermediate'
        },
        {
          name: 'Gerund',
          slug: 'gerund',
          possibleAnswers: [],
          totalExercises: 828,
          level: 'intermediate'
        },
        {
          name: 'Had Better',
          slug: 'had-better',
          possibleAnswers: [],
          totalExercises: 58,
          level: 'advanced'
        },
        {
          name: 'Have Has Got',
          slug: 'have-has-got',
          possibleAnswers: [],
          totalExercises: 125,
          level: 'basic'
        },
        {
          name: 'Infinitive Gerund',
          slug: 'infinitive-gerund',
          possibleAnswers: [],
          totalExercises: 1798,
          level: 'intermediate'
        },
        {
          name: 'Infinitive',
          slug: 'infinitive',
          possibleAnswers: [],
          totalExercises: 769,
          level: 'intermediate'
        },
        {
          name: 'Make Do',
          slug: 'make-do',
          possibleAnswers: [
            'do',
            'make',
            'did',
            'made',
            'doing',
            'making',
            'does',
            'makes'
          ],
          totalExercises: 1990,
          level: 'intermediate'
        },
        {
          name: 'Say Tell',
          slug: 'say-tell',
          possibleAnswers: [
            'say',
            'tell',
            'said',
            'told',
            'says',
            'tells',
            'saying',
            'telling'
          ],
          totalExercises: 1989,
          level: 'intermediate'
        },
        {
          name: 'Tag Questions',
          slug: 'tag-questions',
          possibleAnswers: [],
          totalExercises: 526,
          level: 'intermediate'
        }
      ]
    },
    {
      name: 'Would',
      slug: 'would',
      topics: [
        {
          name: 'Would Like',
          slug: 'would-like',
          possibleAnswers: [],
          totalExercises: 103,
          level: 'intermediate'
        },
        {
          name: 'Would Prefer',
          slug: 'would-prefer',
          possibleAnswers: [],
          totalExercises: 28,
          level: 'advanced'
        },
        {
          name: 'Would Rather',
          slug: 'would-rather',
          possibleAnswers: [],
          totalExercises: 163,
          level: 'intermediate'
        }
      ]
    }
  ]
}
